import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'settings-accounting' */ './Accounting'),
);
